// extracted by mini-css-extract-plugin
export default {"card":"card_card__G042U","detailsText":"card_detailsText__yyGYF"};